import React from 'react'
import Title from '../common/title'

const ContactForm = () => {
    return (
        <div className="contact-form-area pb-75">
            <div className="container">
                <Title sectionName={"Send Us A Message"} sectionTitle={"Get in Touch With Us Today."}/>

                <div className="contact-form-info" data-cue="slideInUp">
                    <form action="https://formsubmit.co/828e60bcfc4217af2230cc0253ee504a" method="POST">
                        
                        <input type="hidden" name="_honey" style={{display: 'none'}} />
                        <input type="hidden" name="_captcha" value="false"/>
                        <input type="hidden" name="form_type" value="CONTACT" />
                        <input type="hidden" name="_next" value="https://j5solutions.org/thanks" />

                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="text" className="form-control" name="name" placeholder="Name" required />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="email" className="form-control" name="email" placeholder="Email" required />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="text" className="form-control" name="phone" placeholder="Phone" />
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="form-group">
                                    <input type="text" className="form-control" name="subject" placeholder="Subject" />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <textarea className="form-control textarea" name="comments" placeholder="Enter Your Comments" rows="3" required ></textarea>
                        </div>
                        
                        <button type="submit">Send A Message</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ContactForm